var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2V14H14V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 2H2V6.875H6.875V2Z",
    fill: "#002E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9.3125H9.3125V14H14V9.3125Z",
    fill: "#002E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 9.3125H2V14H6.875V9.3125Z",
    fill: "#E10019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2H9.3125V6.6875H14V2Z",
    fill: "#E10019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16396 8.04331C9.16396 8.66045 8.66369 9.16072 8.04655 9.16072C7.42942 9.16072 6.92914 8.66045 6.92914 8.04331C6.92914 7.42617 8.04655 6.9259 8.04655 6.9259C8.04655 6.9259 9.16396 7.42617 9.16396 8.04331Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92914 8.04331C6.92914 7.42617 7.42942 6.9259 8.04655 6.9259C8.66369 6.9259 9.16396 7.42617 9.16396 8.04331",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41797 7.48462V8.18299C7.41797 8.53013 7.69937 8.81153 8.0465 8.81153C8.39364 8.81153 8.67504 8.53013 8.67504 8.18299V7.48462H7.41797Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomSm);
export default __webpack_public_path__ + "static/media/DOM-SM.8e105a16bb65016b11c66971c01a3770.svg";
export { ForwardRef as ReactComponent };